<template>
  <div class="expansion-panel-wrapper">
    <div class="expansion-panel-outer">
      <div class="expansion-panel-labels">
        <div class="label-wrapper">
          <p>SENDING AT</p>
        </div>
        <div class="label-wrapper">
          <p>TYPE</p>
        </div>
        <div class="label-wrapper">
          <p>MESSAGE NAME</p>
        </div>
        <div class="label-wrapper">
          <p>FREQUENCY</p>
        </div>
      </div>
      <div class="expansion-panel-spacing"></div>
    </div>
    <div class="expansion-panel-item-wrapper">
      <scheduled-message
        v-for="(message, index) in scheduledMessages"
        :sendingAt="message.sendingAt"
        :scheduledHour="message.scheduledHour"
        :messageType="message.messageType"
        :selectionType="message.selectionType"
        :messageName="message.messageName"
        :messageFrequency="message.messageFrequency"
        :roomList="message.roomList"
        :messageContent="message.messageContent"
        :subjectContent="message.subjectContent"
        :messageID="message.documentID"
        :key="message.documentID"
        @editSelectedMessage="editMessage(index)"
      ></scheduled-message>
    </div>
    <transition name="fadeInModal" mode="out-in">
      <edit-scheduled-message
        v-if="showEditMessage"
        :selectedMessageObject="selectedMessageObject"
        @closeEditing="showEditMessage = false"
      ></edit-scheduled-message>
    </transition>
  </div>
</template>

<script>
import ScheduledMessage from "./ScheduledMessage";
import EditScheduledMessage from "./EditScheduledMessage";

export default {
  components: {
    ScheduledMessage,
    EditScheduledMessage,
  },
  props: {
    scheduledMessagesProp: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showEditMessage: false,
      scheduledMessages: this.scheduledMessagesProp,
      selectedMessageObject: {},
    };
  },
  methods: {
    editMessage(index) {
      this.selectedMessageObject = this.scheduledMessages[index];
      this.showEditMessage = true;
    },
  },
};
</script>

<style scoped>
.expansion-panel-outer {
  display: flex;
  padding: 0px 10px;
}
.expansion-panel-labels {
  flex-grow: 1;
  display: flex;
}
.expansion-panel-spacing {
  display: flex;
  width: 130px;
}
.label-wrapper {
  flex-basis: 28%;
}
.label-wrapper > p {
  text-align: left;
  color: #707070;
}
.pagination-bar-wrapper {
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination-bar-inner-wrapper {
  margin: 0 20px;
  display: flex;
}
.pagination-item {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #707070;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.pagination-item-active {
  background-color: #707070;
  color: #ffffff;
}

@media screen and (max-width: 1025px) {
  .expansion-panel-outer {
    padding: 0;
  }
  .expansion-panel-spacing {
    width: 210px;
  }
}
@media screen and (max-width: 769px) {
  .expansion-panel-outer {
    display: none;
  }
}
</style>
